var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[(_vm.flag)?_c('vFlowProductComponent',{attrs:{"postList":_vm.postList}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }